import React from 'react';

export default function IntellectPlainLogo(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.64988 17.376C9.64988 17.0209 9.93768 16.7331 10.2927 16.7331H10.8001C12.4569 16.7331 13.8 18.0762 13.8 19.733V23.5167C13.8 23.6942 13.6561 23.8381 13.4786 23.8381H9.97129C9.79378 23.8381 9.64988 23.6942 9.64988 23.5167V17.376Z"
        fill="currentColor"
      />
      <path
        d="M13.8283 6.46213C13.8283 6.81715 13.5405 7.10495 13.1855 7.10495H12.6781C11.0213 7.10495 9.67821 5.76188 9.67821 4.1051V0.321413C9.67821 0.143902 9.82211 -1.55185e-08 9.99962 0L13.5069 3.06615e-07C13.6844 3.22133e-07 13.8283 0.143902 13.8283 0.321413L13.8283 6.46213Z"
        fill="currentColor"
      />
      <path
        d="M5.97884 12.8506C6.2863 12.6731 6.67944 12.7784 6.85695 13.0859L7.11066 13.5253C7.93905 14.9601 7.44745 16.7948 6.01264 17.6232L2.73587 19.515C2.58214 19.6038 2.38556 19.5511 2.29681 19.3974L0.543176 16.36C0.454421 16.2063 0.507092 16.0097 0.660821 15.9209L5.97884 12.8506Z"
        fill="currentColor"
      />
      <path
        d="M17.5056 10.9876C17.1982 11.1651 16.805 11.0598 16.6275 10.7523L16.3738 10.3129C15.5454 8.87807 16.037 7.04339 17.4718 6.21501L20.7486 4.32316C20.9023 4.23441 21.0989 4.28708 21.1876 4.4408L22.9413 7.47819C23.03 7.63191 22.9774 7.82849 22.8236 7.91724L17.5056 10.9876Z"
        fill="currentColor"
      />
      <path
        d="M8.05382 7.39368C8.36128 7.57119 8.46662 7.96433 8.28911 8.27179L8.0354 8.71123C7.20702 10.146 5.37234 10.6376 3.93753 9.80925L0.66076 7.9174C0.507031 7.82864 0.454359 7.63207 0.543115 7.47834L2.29675 4.44096C2.3855 4.28723 2.58208 4.23456 2.73581 4.32332L8.05382 7.39368Z"
        fill="currentColor"
      />
      <path
        d="M15.4302 16.4445C15.1228 16.267 15.0174 15.8738 15.1949 15.5664L15.4486 15.127C16.277 13.6921 18.1117 13.2005 19.5465 14.0289L22.8233 15.9208C22.977 16.0095 23.0297 16.2061 22.9409 16.3598L21.1873 19.3972C21.0985 19.5509 20.902 19.6036 20.7482 19.5149L15.4302 16.4445Z"
        fill="currentColor"
      />
      <path
        d="M14.5056 11.9284C14.5056 13.4468 13.2747 14.6777 11.7563 14.6777C10.2379 14.6777 9.00697 13.4468 9.00697 11.9284C9.00697 10.41 10.2379 9.17908 11.7563 9.17908C13.2747 9.17908 14.5056 10.41 14.5056 11.9284Z"
        fill="currentColor"
      />
    </svg>
  );
}
